// react
import { Map } from "immutable";

const initialState = Map({
	integrationName: null,
	lastUpdate: null,
	walkthroughStatus: null,
	connectedUrl: null,
	connected: false,
	adpToken: null,
	fetchedSetup: false,
	adpFields: Map(),
	needsConsent: false,
	isOptimisticFetching: false,
	availableExternalFields: [],
});

export default function jobs(state = initialState, action) {
	switch (action.type) {
		case "INTEGRATIONS:SETUP@SUCCESS": {
			const { response } = action;

			return state.withMutations((mutable) => {
				mutable.set("fetchedSetup", true);
				mutable.set("connected", response.get("connected"));
				mutable.set("integrationName", response.get("name"));
				mutable.set("lastUpdate", response.get("lastUpdate"));
				mutable.set("connectUrl", response.get("connectUrl"));
				mutable.set("walkthroughStatus", response.get("walkthroughStatus"));
				mutable.set("adpToken", response.get("adpToken"));
				mutable.set("needsConsent", response.get("needsConsent"));
				mutable.set("externalCompanyID", response.get("externalCompanyID"));
				mutable.set("organization", response.get("organization"));
				mutable.set("isCredentialResetting", response.get("isCredentialResetting"));
			});
		}

		case "INTEGRATIONS:GETFIELDS@SUCCESS": {
			const { response } = action;
			const { fields, externalFields } = response;

			return state.withMutations((mutable) => {
				mutable.set("adpFields", fields);
				mutable.set("availableExternalFields", externalFields);
			});
		}

		case "INTEGRATIONS:SETOPTIMISTICFETCHSTATE": {
			const { nextState } = action;
			return state.set("isOptimisticFetching", nextState);
		}

		case "INTEGRATIONS:SET_EXTERNAL_FIELDS": {
			const { fields } = action;

			return state.withMutations((mutable) => {
				mutable.set("availableExternalFields", fields);
			});
		}

		default:
			// never forget your default return state!
			return state;
	}
}
